<template>
  <BaseFrame>
    <div class="container flex justify-between">
      <MypageSidebar class="desktop:w-2/12 mobile:hidden"/>

      <div class="desktop:w-9/12 mobile:w-full">
        <router-view />
      </div>
    </div>
  </BaseFrame>
</template>

<script lang="ts" setup>
import { onUnmounted, onMounted } from "vue";
import { useStore } from "vuex";
import { onBeforeRouteUpdate } from "vue-router";
import { useUserData } from "@/lib/mypage/useMypage";

import BaseFrame from "./baseComponent/baseFrame.vue";
import MypageSidebar from "@/components/ui/mypage/sideBar.vue";

const store = useStore();
const { setupUserData } = useUserData();

const resetUserData = () => {
  store.dispatch("mypage/resetClient");
  store.dispatch("mypage/resetCenter");
  store.dispatch("mypage/resetGroup");
  store.dispatch("mypage/resetUnit");
  store.dispatch("mypage/resetMarketing");
};

onMounted(() => {
  onBeforeRouteUpdate(async (to, from) => {
    await setupUserData();
  });
});
onUnmounted(() => resetUserData());
</script>

<style lang="scss">
@import "@/assets/style/screens/screen.scss";
</style>
